module.exports = __webpack_public_path__ + "static/scale-model-of-veterans-park-in-lexington-kentucky-56f4711c260bd711c1f257be0e1bd452.png";